export default "__VITE_ASSET__3ac7ad6c__"